(function() {
  document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (e) => {
      if (e.target.closest('.voo-tab-title') || e.target.classList.contains('voo-tab-title')) {
        const target = e.target.closest('.voo-tab-title') || e.target;

        if (!e.target.closest('.voo-tab-details').classList.contains('active')) {
          target.nextElementSibling.style.height = `${target.nextElementSibling.firstElementChild.offsetHeight}px`;
        }

        e.target.closest('.voo-tab-details').classList.toggle('active');
      }

      if (e.target.closest('.voo-answer') || e.target.classList.contains('voo-answer')) {
        const target = e.target.closest('.voo-answer') || e.target;
        const wrapper = target.closest('.voo-question-wrapper');

        if (!wrapper) return;

        if (!target.classList.contains('active')) {
          wrapper.querySelector('.voo-answer.active')?.classList.remove('active');
        };

        target.classList.toggle('active');
      }
    });
  });
})();
